/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentDtoListApiResponse } from '../../models/document-dto-list-api-response';

export interface UploadExpenseDocumentAsync$Plain$Params {
  id: number;
      body?: {
'ExpenseId'?: number;
'File'?: Blob;
}
}

export function uploadExpenseDocumentAsync$Plain(http: HttpClient, rootUrl: string, params: UploadExpenseDocumentAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDtoListApiResponse>> {
  const rb = new RequestBuilder(rootUrl, uploadExpenseDocumentAsync$Plain.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentDtoListApiResponse>;
    })
  );
}

uploadExpenseDocumentAsync$Plain.PATH = '/api/expense/{id}/document';
